// src/modules/public/pages/LandingPage/index.js
import React, { useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../shared/hooks/useAuth';
import './styles.css';

const FeatureCard = ({ title, description, icon }) => (
    <Card className="feature-card">
        <Card.Body>
            <div className="feature-icon">{icon}</div>
            <Card.Title>{title}</Card.Title>
            <Card.Text>{description}</Card.Text>
        </Card.Body>
    </Card>
);

const LandingPage = () => {
    const { isAuthenticated } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/fithub');
        }
    }, [isAuthenticated, navigate]);

    return (
        <Container className="landing-page">
            <div className="hero-section">
                <h1>Welcome to FitOps</h1>
                <p className="lead">
                    Track, compete, and celebrate fitness achievements with your colleagues
                </p>
                <div className="cta-buttons">
                    <Link to="/login" className="btn btn-primary btn-lg me-3">
                        Login
                    </Link>
                    <Link to="/signup" className="btn btn-outline-primary btn-lg">
                        Sign Up
                    </Link>
                </div>
            </div>

            <Row className="features-section">
                <Col md={4}>
                    <FeatureCard
                        title="Minister of Activity"
                        description="Compete monthly to earn the prestigious title and avoid cake duty!"
                        icon="👑"
                    />
                </Col>
                <Col md={4}>
                    <FeatureCard
                        title="Track Activities"
                        description="Log your runs, rides, swims, and hikes with detailed statistics"
                        icon="📊"
                    />
                </Col>
                <Col md={4}>
                    <FeatureCard
                        title="Team Spirit"
                        description="Join your colleagues in friendly competition and celebration"
                        icon="🎉"
                    />
                </Col>
            </Row>

            <div className="rules-preview">
                <h2>How It Works</h2>
                <Row className="g-4">
                    <Col md={6}>
                        <div className="rule-item">
                            <h4>🏆 Monthly Competition</h4>
                            <p>Participate in monthly challenges to become the Minister of Activity</p>
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className="rule-item">
                            <h4>🍰 Cake Threshold</h4>
                            <p>Meet the monthly point target or bring cake for those who did!</p>
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className="rule-item">
                            <h4>📱 Activity Tracking</h4>
                            <p>Connect with popular fitness apps to log your activities</p>
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className="rule-item">
                            <h4>🏃‍♂️ Multiple Activities</h4>
                            <p>Running, cycling, swimming, hiking - all count towards your score</p>
                        </div>
                    </Col>
                </Row>
                <Link to="/rules" className="btn btn-link mt-4">
                    View Complete Rules →
                </Link>
            </div>
        </Container>
    );
};

export default LandingPage;
